/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditDetailsDTO } from '../models/AuditDetailsDTO';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class AuditsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async auditsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/audits/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AuditDetailsDTO OK
     * @throws ApiError
     */
    public static async auditsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<AuditDetailsDTO> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/audits/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}